import * as yup from 'yup';

export const ProfileSchema = yup.object().shape({
  username: yup.string()
    .min(2, 'Минимум 2 символа')
    .max(120, 'Максимум 120 символов')
    .matches(
      /^[a-zA-Zа-яА-Я0-9_.@-]+$/,
      'Логин может содержать только буквы, цифры, подчеркивания, точки, @ и дефисы.'
    ),
  first_name: yup
    .string()
    .min(2, 'Имя должно содержать минимум 2 символа')
    .max(20, 'Имя должно содержать максимум 20 символов'),
  patronymic: yup
    .string()
    .max(20, 'Отчество должно содержать максимум 20 символов')
    .nullable(),
  last_name: yup
    .string()
    .min(2, 'Фамилия должна содержать минимум 2 символа')
    .max(20, 'Фамилия должна содержать максимум 20 символов'),
  email: yup
    .string()
    .email('Пожалуйста, введите корректный адрес электронной почты'),
  mobile_phone: yup
    .string()
    .matches(
      /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
      'Пожалуйста, введите корректный номер телефона'
    ),
  telegram: yup
    .string()
    .test(
      'is-valid-telegram-or-empty',
      'Пожалуйста, введите корректный телеграм',
      (value) => {
        if (!value || value.length < 2) return true;
        return /^[a-zA-Zа-яА-Я0-9_.@-]+$/.test(value);
      }
    )
    .nullable(),
  whatsapp: yup
    .string()
    .test(
      'is-valid-whatsapp-or-empty',
      'Пожалуйста, введите корректный whatsapp',
      (value) => {
        if (!value || value.length < 2) return true;
        return /^[a-zA-Zа-яА-Я0-9_.@-]+$/.test(value);
      }
    )
    .nullable(),
  additional_phone: yup
    .string()
    .test(
      'is-valid-phone-or-empty',
      'Пожалуйста, введите корректный дополнительный номер телефона',
      (value) => {
        if (!value || value.length < 2) return true;
        return /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value);
      }
    )
    .nullable(),
});

export const IntegratorSchema = yup.object().shape({
  login: yup
    .string()
    .required('Обязательное поле')
    .min(2, 'Минимум 2 символа')
    .max(120, 'Максимум 120 символов')
    .matches(
      /^[a-zA-Zа-яА-Я0-9_.@]+$/,
      'Логин должен содержать буквы и может содержать цифры, подчеркивания, точки и @'
    ),
  emails: yup.array().of(
    yup.object().shape({
      email: yup.string().email('Неверный формат электронной почты'),
    })
  ),
  email: yup
    .string()
    .required('Обязательное поле')
    .email('Неверный формат электронной почты'),
});

export const EmailSchema = yup.object().shape({
  email: yup
    .string()
    .required('Обязательное поле')
    .email('Неверный формат электронной почты'),
});
